import { render, staticRenderFns } from "./SChip.vue?vue&type=template&id=68d4fd9e&scoped=true&lang=pug"
import script from "./SChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./SChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SChip.vue?vue&type=style&index=0&id=68d4fd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d4fd9e",
  null
  
)

export default component.exports